import { railsConfig, HYDRA_SEGMENT_URL } from '../RailsConfig';
import {
  RailsAbConfig,
  getRailsFcPremiumPokus,
  getRailsFcTgTogetherValue,
  getRailsTGVersion,
  showSocialProofingFc,
  showSocialProofingTg,
  getIfCanShowBNPP,
} from 'apps/rails/src/RailsAbConfig';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import fecha from 'fecha';
import { stringCompare } from '../pages/TravelerDetails/TravelerDetailsUtils';
import fetch2 from '../fetch2';
import { getCommonHeaders } from '@mmt/legacy-commons/Helpers/genericHelper';
import { getRailofyZcShownInLS, saveRailofyZcShownInLS } from './railofyUtils';
import { bookMode } from './device';
import { getUserDetails } from '@mmt/legacy-commons/Native/UserSession/UserSessionModule';

import {
  ACCEPT_ENCODING_HEADER_NAME,
  GZIP_ENCODING,
  CONTENT_TYPE_HEADER_NAME,
  CONTENT_TYPE,
  API_KEY_HEADER_NAME,
  API_KEY,
  HOST_HEADER_NAME,
  HYDRA_HOST_URL,
  HYDRA_SERVICE_NAME,
  HYDRA_SERVICE_VALUE,
  HYDRA_SEGMENTS_NAME,
  HYDRA_SEGMENT_RAILS,
  USER_ID_HEADER_NAME,
  PROFILE_TYPE_HEADER_NAME,
  MMT_AUTH_HEADER_NAME,
  RAIL_USER_ADDRESS_AUTHORIZATION,
  RAIL_USER_ADDRESS_API_KEY
} from './RailsConstant';

export const getBoardingStationURL = (selectedTrainInfo, journeyDate, classCalue) => {
  const srcCode = selectedTrainInfo.frmStnCode;
  const destCode = selectedTrainInfo.toStnCode;
  const dateStr = fecha.format(journeyDate, 'YYYYMMDD');
  return `${railsConfig.boardingStationUrl}/${selectedTrainInfo.trainNumber}/${dateStr}/${srcCode}/${destCode}/${classCalue.code}`;
};


const buildBoardingStationList = (response, selectedTrainInfo) => {
  const boardingStnList = [];
  forEach(response.boardingStationsList, (station) => {
    const newStn = {
      stationCode: station.stationCode,
      stationName: station.stationName,
      departureTime: station.time,
      date: station.date
    };
    if (!stringCompare(selectedTrainInfo.toStnCode, newStn.stationCode)) {
      boardingStnList.push(newStn);
    }
  });
  return boardingStnList;
};

export const getBoardingStation = async (selectedTrainInfo, classValue) => {
  let newPickupStationList = [];
  try {
    const trainRouteUrl = getBoardingStationURL(selectedTrainInfo, selectedTrainInfo.departureDateAndTime, classValue);
    const res = await fetch2(trainRouteUrl);

    if (res.status === 200) {
      const responseJson = await res.json();
      newPickupStationList = buildBoardingStationList(responseJson, selectedTrainInfo);
    } else {
      console.log('Failed to Fetch the data from the server, Status :', res.status);
    }
  } catch (error) {
    console.error(`error is:${error}`);
  }
  return newPickupStationList;
};


export const getBookingReview = async (bookingReviewRequest, railsTraveler, bookingSource) => {
  try {
    const { userDetails } = railsTraveler;
    const mmtAuth = get(userDetails, 'mmtAuth', null);
    let bkngSrc = bookingSource;
    if (bkngSrc && bkngSrc.toLowerCase().includes('irctc')) {
      bkngSrc = 'IRCTC'
    }
    const headerObject = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...(bkngSrc && { 'booking-source': bkngSrc })
    };
    const headers = isEmpty(mmtAuth) ? headerObject : { ...headerObject, 'mmt-auth': mmtAuth };
    const response = await fetch2(railsConfig.bookingReviewUrl, {
      method: 'POST',
      headers,
      body: JSON.stringify(bookingReviewRequest)
    });
    if (response.status) {
      const jsonResponse = await response.json();
      return jsonResponse;
    }
  } catch (error) {
    console.log('Error in fetchBookingReview : ', error);
    return null;
  }
};

async function getHydraApiRequestDetails() {
  const { mmtAuth, uuid, profileType } = await getUserDetails();
  const getHeaderForHydraApi = () => {
    return {
      [ACCEPT_ENCODING_HEADER_NAME]: GZIP_ENCODING,
      [CONTENT_TYPE_HEADER_NAME]: CONTENT_TYPE,
      [API_KEY_HEADER_NAME]: API_KEY,
      ... (mmtAuth ? { [MMT_AUTH_HEADER_NAME]: mmtAuth } : {})
    }
  };

  const getBodyForHydraApi = () => {
    return {
      [HYDRA_SERVICE_NAME]: HYDRA_SERVICE_VALUE,
      [HYDRA_SEGMENTS_NAME]: [
        HYDRA_SEGMENT_RAILS
      ],
      [USER_ID_HEADER_NAME]: {
        uuid,
        [PROFILE_TYPE_HEADER_NAME]: profileType,
      }
    };
  }
  return { getHeaderForHydraApi, getBodyForHydraApi };
};

export const getHydraSegment = async () => { 
  try {

    const { getHeaderForHydraApi , getBodyForHydraApi } = await getHydraApiRequestDetails()
    const headers = getHeaderForHydraApi();
    const body = getBodyForHydraApi();

    const response = await fetch2(HYDRA_SEGMENT_URL, {
      method: 'POST',
      headers,
      body: JSON.stringify(body)
    });

    const jsonResponse = await response.json();
    return jsonResponse;

  } catch(error){
    console.log('Error in Rails getHydraSegment : ',error);
    return null 
  }
}

export const getFreeCancellationConfigurationApi = async (data) => {
  try {
    const url = railsConfig.freeCancellationUrl;
    const freeCancellationRequest = {
      reservationChoice: '99',
      source: data?.originStation?.code,
      destination: data?.destinationStation?.code,
      class: data?.classCode,
      quota: data?.quota,
      doj: data?.availabilityObject?.availablityDate?.split('-').reverse().join(''),
      trainNumber: data?.trainNumber,
      bookMode: bookMode(),
    };
    const commonHeaders = await getCommonHeaders();
    const headers = {
      ...commonHeaders,
      'Content-Type': 'application/json',
    };
    const freeCancellationResponse = await fetch2(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(freeCancellationRequest),
    });
    const response = await freeCancellationResponse.json();
    if (response.response) {
      return response.response;
    } else {
      return {};
    }
  } catch (error) {
    console.log('getFreeCancellationConfigurationApi error', error);
    return {};
  }
};

export const assuredConfirmationConfigurationApi = async (data = {}, railsConfirmationGuaranteeOption) => { // railofy
  try {
    const url = railsConfig.assuredConfirmationUrl;
    let { railofyZcShown: { railofyShown, zcShown } = {} } = data;
    const bnppShown = await getIfCanShowBNPP();
    if (
      typeof railofyShown === 'undefined' ||
      typeof zcShown === 'undefined'
    ) {
      const lsData = await getRailofyZcShownInLS();
      railofyShown = lsData.railofyShown;
      zcShown = lsData.zcShown;
    } else {
      saveRailofyZcShownInLS({ railofyShown, zcShown, bnppShown });
    }


    const assuredConfirmationRequest = {
      reservationChoice: '99',
      source: data.source,
      destination: data.destination,
      class: data.classCode,
      quota: data.quota,
      doj: data.doj,
      trainNumber: data.trainNumber,
      bookMode: bookMode(),
      railsConfirmationGuaranteeOption,
      railofyShown,
      zcShown,
      bnppShown,
      departureTime: data.departureTime,
      pokusState: {
        [RailsAbConfig.railsTGPlus]: await getRailsTGVersion(),
        [RailsAbConfig.railsFcTgTogether]: await getRailsFcTgTogetherValue(),
        [RailsAbConfig.railsFcPremiumPercentage]: getRailsFcPremiumPokus() || 0,
        [RailsAbConfig.railsSocialProofingFreeCancellation]: showSocialProofingFc() || 0,
        [RailsAbConfig.railsSocialProofingTripGuarantee]: showSocialProofingTg() || 0,
      },
    };

    const commonHeaders = await getCommonHeaders();
    const headers = {
      ...commonHeaders,
      'Content-Type': 'application/json',
    };
    const assuredConfirmationResponse = await fetch2(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(assuredConfirmationRequest),
    });
    const response = await assuredConfirmationResponse.json();
    if (response.response) {
      return response.response;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

export const bookingCheckoutAPIForPaymentInfo = async (checkoutRequestBody) => {
  try {
    const url = railsConfig.bookingCheckoutUrl;
    const commonHeaders = await getCommonHeaders();
    const headers = {
      ...commonHeaders,
      'Content-Type': 'application/json',
    };

    const checkoutResponse = await fetch2(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(checkoutRequestBody),
    });

    const response = await checkoutResponse.json();

    if(response) {
      return response;
    } else return null;

  } catch(err) {
    return null;
  }
};

export const fetchUserAddressDataBasedOnUserIP = async () => {
  var myHeaders = new Headers();
  myHeaders.append("authorization", RAIL_USER_ADDRESS_AUTHORIZATION);
  myHeaders.append("api-key", RAIL_USER_ADDRESS_API_KEY);
  myHeaders.append("Content-Type", "text/plain");

  var raw = "{\nlocationHierarchy(lat:,lng:) {\ncountry {\nid\nname\ncentre\n}\nstate {\nid\nname\ncentre\n}\ncity {\nid\nname\ncentre\npostal_code\n}\narea {\nid\nname\nprimary_area\ncentre\npostal_code\n}\n}\n}\n";

  var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
  };

  const response = await fetch(railsConfig?.userAddressDataUrl, requestOptions)
  const jsonResponse = await response.json();

  return jsonResponse;
}
